import { Icon, IconProps } from "@chakra-ui/react";

export default function CaminoWarningTriangle(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 17 16"
      {...props}
      fill="none"
    >
      <path
        d="M8.50005 6.00008V8.66674M8.50005 11.3334H8.50713M7.2888 2.57341L1.28921 12.0001C1.16551 12.2017 1.10006 12.4303 1.09937 12.6631C1.09868 12.8959 1.16277 13.1248 1.28526 13.3271C1.40776 13.5294 1.58439 13.6979 1.79759 13.816C2.01078 13.934 2.25311 13.9975 2.50046 14.0001H14.4996C14.747 13.9975 14.9893 13.934 15.2025 13.816C15.4157 13.6979 15.5923 13.5294 15.7148 13.3271C15.8373 13.1248 15.9014 12.8959 15.9007 12.6631C15.9 12.4303 15.8346 12.2017 15.7109 12.0001L9.7113 2.57341C9.58502 2.37748 9.40722 2.21549 9.19506 2.10306C8.98289 1.99064 8.74352 1.93158 8.50005 1.93158C8.25657 1.93158 8.0172 1.99064 7.80503 2.10306C7.59287 2.21549 7.41507 2.37748 7.2888 2.57341Z"
        stroke={props.stroke ?? "var(--chakra-colors-error-DEFAULT)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
}
